import React from "react";
import { Container, Row } from "react-bootstrap";
// import AboutCardHome from "./AboutCardHome";
// import Services from "./Services";
// import OurFleet from "./OurFleet";
import Testimonials from "./Testimonials";
import MeetJoanHome from "./MeetJoanHome";
import { useTranslation } from "react-i18next";
import PortfolioV, { itemsHome } from "../Academia/PortfolioV";

function About({ cookiesAccepted }) {
   const { t } = useTranslation();
   
  return (
     <Container fluid className="about-section">
        <Row className="about-row">
           <Row className="about">
              <div
                 className="skill-section-container"
                 id="skills"
                 data-aos="fade-in"
                 data-aos-duration="2000"
              >
                 <div className="habilities">
                    <h2>{t("services_withdrones")}</h2>
                    <p>
                       {t("services_desc")}
                       <strong>{t("services_desc_strong")}</strong>
                    </p>
                 </div>
                 {/* <Services /> */}
                 <PortfolioV cookiesAccepted={cookiesAccepted} HomePage={true} items={itemsHome} />
              </div>
              <MeetJoanHome />
              {/* <AboutCardHome /> */}
              <div
                 className="skill-section-testimonials-container"
                 id="testimonials"
              >
                 <Testimonials />
              </div>
              {/* <OurFleet /> */}
           </Row>
        </Row>
     </Container>
  );
}

export default About;
